import { useState, useEffect } from 'react';

export default function useWindowSize() {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );
  const [height, setHeight] = useState(
    typeof window !== 'undefined' ? window.innerHeight : 0
  );

  function handleResize() {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize, { passive: true });
    return function cleanupResizeListener() {
      window.removeEventListener('resize', handleResize);
    };
  });

  return { width, height };
}
